import React, {Fragment} from 'react';
import {contextFormsList} from './formsContextList';
import _ from 'lodash';
import ContextMiniFormWrapper from './contextFormWrapper';

const ContextFormContainer = (props) => {
    const miniForms = _.filter(contextFormsList, f => f.isMiniForm);

    // Props
    const {patientType, ...restProps} = props;

    return (
        <>
            {miniForms.map(form => {
                return (
                    <Fragment key={form.id}>
                        <ContextMiniFormWrapper
                            form={form}
                            patientType={patientType}
                            {...restProps}
                        />
                    </Fragment>
                );
            })}
        </>
    );
};

export default ContextFormContainer;